import axios from 'axios';

export const getScreenHostAccount = (token) => {
    return axios.get(process.env.REACT_APP_API_URL + '/screenHost/account', {
        headers: { Authorization: token }
    });
};
